'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id) {
  var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      status: status

    }, _middleware.CALL_API, {
      config: {
        url: '' + (0, _paths.releaseCommentsFlagUrl)(feis_id, event_id, status),
        method: 'PUT'
      },
      types: ['SET_RELEASE_COMMENTS_STATUS_START', 'SET_RELEASE_COMMENTS_STATUS', 'SET_RELEASE_COMMENTS_STATUS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/updateReleaseComments.js
// module id = 652
// module chunks = 0